import { gql } from '@apollo/client';

export default gql`
  mutation UnassignMatchSquadShift($input: UnassignMatchSquadShiftInput!) {
    unassignMatchSquadShift(input: $input) {
      id
    }
  }
`;
